import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { SERVICES } from "../data/translations";
import { Reveal } from "../components/Reveal";

const Services = () => {
  const { lang, t } = useLanguage();
  const s = t.servicesPage;

  return (
    <div className="bg-ink" data-testid="services-page">
      <section className="relative pt-40 pb-16 bg-ink-surface border-b border-white/5 bg-grid" data-testid="services-header">
        <div className="container-site">
          <p className="eyebrow">{s.eyebrow}</p>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white max-w-3xl leading-[1.05]">{s.title}</h1>
          <p className="mt-6 max-w-xl text-slate-400">{s.subtitle}</p>
        </div>
      </section>

      {SERVICES.map((svc, i) => {
        const Icon = svc.icon;
        const c = svc[lang];
        return (
          <section
            key={svc.id}
            className={`!py-16 sm:!py-20 ${i % 2 === 0 ? "bg-ink" : "bg-ink-surface border-y border-white/5"}`}
            data-testid={`service-section-${svc.id}`}
          >
            <div className="container-site grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
                <div className="flex items-center gap-4">
                  <span className="font-mono text-sm text-brand tracking-widest">{String(i + 1).padStart(2, "0")}</span>
                  <span className="h-px w-12 bg-brand/50" />
                  <div className="w-10 h-10 bg-brand/10 border border-brand/30 flex items-center justify-center text-brand">
                    <Icon size={18} />
                  </div>
                </div>
                <h2 className="mt-6 font-display text-2xl sm:text-3xl font-bold text-white">{c.title}</h2>
                <p className="mt-4 text-slate-400 leading-relaxed">{c.desc}</p>
                <p className="mt-6 mini-label">{s.bulletsLabel}</p>
                <ul className="mt-4 grid sm:grid-cols-2 gap-3">
                  {c.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-slate-200">
                      <ArrowRight size={15} className="text-brand shrink-0 mt-0.5" /> {b}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" data-testid={`service-quote-${svc.id}`} className="mt-8 btn-outline !px-5 !py-2.5">
                  {t.nav.quote} <ArrowRight size={14} />
                </Link>
              </Reveal>
              <Reveal delay={0.12} className={i % 2 === 1 ? "lg:order-1" : ""}>
                {svc.image ? (
                  <img src={svc.image} alt={c.title} className="w-full h-72 sm:h-80 object-cover border-2 border-brand" />
                ) : (
                  <div className="relative h-72 sm:h-80 bg-ink-card border border-white/10 bg-grid flex items-center justify-center overflow-hidden">
                    <Icon size={110} strokeWidth={1} className="text-brand/80" />
                    <span className="absolute bottom-4 right-7 font-display text-7xl font-extrabold text-stroke">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                )}
              </Reveal>
            </div>
          </section>
        );
      })}

      <section className="bg-black border-t border-white/10 !py-16 sm:!py-20" data-testid="services-process">
        <div className="container-site">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white">{s.processTitle}</h2>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-6">
            {s.process.map((step, i) => (
              <Reveal key={step} delay={i * 0.08}>
                <div className="relative" data-testid={`process-step-${i + 1}`}>
                  <div className="w-11 h-11 bg-brand text-black font-display font-extrabold flex items-center justify-center text-lg">
                    {i + 1}
                  </div>
                  <p className="mt-4 font-display font-semibold text-white">{step}</p>
                  {i < 3 && <span className="hidden lg:block absolute top-5 left-14 right-0 h-px bg-white/10" />}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
